import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  IconButton,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from "axios";
import QuestionUpdateForm from "./QuestionUpdateForm";
import ConfirmationModal from "../../Modals/ConfirmationModal/ConfirmationModal";
import { updateAssignmentQuestionsAction } from "../../../actions/updateAssignmentQuestions";
import { useSetAssignment } from "../../../globals/AssignmentContext";

const { REACT_APP_DEBUGGER_SERVER_URL } = process.env;

export default function TeacherQuestionView(props) {
  const setAssignment = useSetAssignment();
  const [singleQuestion, setSingleQuestion] = useState({});
  const [expanded, setExpanded] = React.useState(false);

  const { assignment } = props;
  const { questionNumber } = props;
  const { questionID } = props;
  const { saveAssignment } = props;
  const { disabled } = props;

  useEffect(() => {
    async function getQuestion() {
      let question = (typeof questionID === "string") ? questionID : questionID._id
      const res = await axios
        .get(`${REACT_APP_DEBUGGER_SERVER_URL}/question/` + question)
        .catch((error) => {
          console.log(error);
        });
      setSingleQuestion(res.data);
    }

    getQuestion();
  }, [questionID]);

  const handleRemove = async () => {
    let questions = assignment.questions;
    questions.splice(questions.indexOf(questionID), 1);
    await updateAssignmentQuestionsAction(assignment._id, questions, setAssignment).then(() => {
      saveAssignment()
  });
  };

  const [confirmationModalOpen, setConfirmationModalOpen] =
    React.useState(false);
  const handleConfirmationOpen = (event) => {
    setConfirmationModalOpen(true);
    event.stopPropagation();
  };
  const handleConfirmationClose = () => setConfirmationModalOpen(false);

  return (
    <Container key={questionID} component="main" sx={{ paddingTop: "4px" }}>
      <Accordion
        expanded={expanded}
        elevation={3}
        onClick={() => setExpanded(!expanded)}
        disabled={disabled}
      >
        <AccordionSummary
          sx={{
            display: "flex",
            "& .MuiAccordionSummary-contentGutters": { margin: "0px" },
            "& .css-nelwl5-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded":
              { minSize: "48px" },
          }}
          expandIcon={<ExpandMoreIcon />}
        >
          <Grid
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              flex: "auto",
            }}
          >
            <Typography variant="h6" sx={{ margin: "5px 0px" }}>
              Question {questionNumber}
            </Typography>
            <IconButton
              color="primary"
              arialabel="edit"
              onClick={handleConfirmationOpen}
            >
              <RemoveCircleIcon />
            </IconButton>
          </Grid>
        </AccordionSummary>
        <AccordionDetails onClick={(e) => e.stopPropagation()}>
          {Object.keys(singleQuestion).length !== 0 ? (
            <QuestionUpdateForm
              question={singleQuestion}
              questionNumber={questionNumber}
              saveAssignment={saveAssignment}
              setExpanded={setExpanded}
              disabled={disabled}
            ></QuestionUpdateForm>
          ) : (
            <></>
          )}
        </AccordionDetails>
      </Accordion>
      <ConfirmationModal
        notification="Remove this question?"
        onSubmit={handleRemove}
        open={confirmationModalOpen}
        setOpen={setConfirmationModalOpen}
        handleClose={handleConfirmationClose}
      ></ConfirmationModal>
    </Container>
  );
}
